import { Modal, Form, Input} from "antd";
import { useState } from "react";
import "./AddEmployeeModal.css";

const LozinkaModal = ({ open, onCancel, onCreate, korisnickoIme, ime, prezime, staraLozinka }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await onCreate({
        korisnickoIme,
        staraLozinka,
        novaLozinka: values.novaLozinka,
      });
      form.resetFields();
    } catch (err) {
      alert("Greška prilikom promjene lozinke");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      wrapClassName="addemployee"
      open={open}
      title="Promjena lozinke"
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={submitting}
      okText="Potvrdi"
      cancelText="Otkaži"
    >
      <div style={{ marginBottom: 16 }}>
        <p><strong>Korisničko ime:</strong> {korisnickoIme}</p>
        <p><strong>Ime i prezime:</strong> {ime} {prezime}</p>
      </div>
      <Form form={form} layout="vertical">
        <Form.Item
          name="novaLozinka"
          label="Nova lozinka"
          rules={[{ required: true, message: "Unesite novu lozinku" }]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default LozinkaModal;